import React from "react";
import {ActionRow, ActionRowButton, ActionRowMoreButton, Icon} from "peggirkit";
import {PlusIcon, TrashIcon} from "@heroicons/react/24/outline";
import {FormattedMessage} from "react-intl";
import router from "@/routing/Router";
import {SetStateFn} from "@/utils/SetStateUtils";
import {useFormContext} from "react-hook-form";
import {FeaturedProductDetails} from "@/data/entities/product";


type Props = {
    setShowDeleteModal: SetStateFn<boolean>,
    setFeaturedProduct: SetStateFn<FeaturedProductDetails | null>,
};

const FeaturedProductHeadingActions = ({setShowDeleteModal, setFeaturedProduct}: Props) => {
    const {reset} = useFormContext();

    return (
        <ActionRow
            useMoreButton={true}
            moreButton={
                <ActionRowMoreButton>
                    <FormattedMessage id={"more"}/>
                </ActionRowMoreButton>
            }
            moreButtonPositioning={"end"}
            breakpoints={{
                md: {
                    moreButtonPositioning: "start",
                },
            }}
        >
            <ActionRowButton
                color={"danger"}
                iconBefore={<Icon icon={TrashIcon}/>}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: e => {
                            e.preventDefault();
                            setShowDeleteModal(true);
                        },
                    },
                }}
                showInRowBreakpoint={"xl"}
            >
                <FormattedMessage id={"delete"}/>
            </ActionRowButton>

            <ActionRowButton
                color={"secondary"}
                iconBefore={<Icon icon={PlusIcon}/>}
                buttonAction={{
                    as: "reactRouterLink",
                    actionProps: {
                        to: router.newFeaturedProduct.absolutePath(),
                        onClick: () => {
                            reset();
                            setFeaturedProduct(null);
                        }
                    }
                }}
            >
                <FormattedMessage id={"newFeaturedProduct"}/>
            </ActionRowButton>
        </ActionRow>
    );
};

export default FeaturedProductHeadingActions;